<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="9000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title> Offline Wallet Payment </v-toolbar-title>
            </v-toolbar>
            <br />
            <v-row dense justify="center">
                <v-col cols="12" sm="5" md="5">
                    <v-autocomplete rounded :items="stud_list" v-model="stud_data" item-text="name"
                        label="Search Student" dense return-object outlined :loading="comp_load" @change="getData"
                        placeholder="Search by PRN No or name"></v-autocomplete>
                </v-col>
            </v-row>
            <v-card class="box" v-if="basic_student_data != null">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title> Student Details </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12">
                    <v-row justify="center" dense>
                        <v-col cols="12" sm="6" md="6"><strong>Name : </strong>{{ basic_student_data.registration_number
                            }} : {{ basic_student_data.student_name }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Admission Year : </strong>{{
                            basic_student_data.learner_addmission_year }}</v-col>
                        <v-col cols="12" sm="3" md="3" class="flash"><strong>Current Wallet Balance : {{
                                current_wallet_balance }}</strong></v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Standard : </strong>{{ basic_student_data.standard
                            }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Division : </strong>{{ basic_student_data.division
                            }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Roll No. : </strong>{{ basic_student_data.roll_no
                            }}</v-col>
                        <v-col cols="12" sm="3" md="3"><strong>Quota : </strong>{{ basic_student_data.quota }}</v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-autocomplete dense rounded required :items="mode_list" item-text="name" item-value="id"
                                v-model="mode" label="Payment Mode" name="mode" persistent-hint
                                hint="Please Select Payment Mode" outlined></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-autocomplete dense rounded required :items="bank_list" v-model="bank" label="Bank"
                                name="bank" persistent-hint hint="Please Select Bank" item-text="name" item-value="id"
                                outlined></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-text-field outlined rounded label="Transaction ID" v-model="trans_id" placeholder="123"
                                persistent-hint hint="Please Enter Transaction Id" name="trans_id" dense></v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" sm="3" md="3">
                            <v-menu v-model="menu12" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        dense
                                        outlined
                                        rounded
                                        v-model="mode_date"
                                        label="Transaction Date"
                                        hint="Please Select Transaction Date"
                                        name="mode_date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="mode_date" name="mode_date" @input="menu12 = false"></v-date-picker>
                            </v-menu>
                        </v-col> -->
                        <v-col cols="12" sm="3" md="3">
                            <v-text-field label="Amount To Pay" v-model="amount" placeholder="123" type="number" dense
                                rounded outlined hint="Please Enter Amount It's Rsequired"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row v-if="basic_student_data != null" justify="center" dense>
                        <v-btn @click="payFee()" v-if="mode && amount" :loading="loader" class="button">Pay</v-btn>
                    </v-row>
                </v-col>
            </v-card>
            <v-card class="box" v-if="basic_student_data != null">
                <v-expansion-panels class="expapanel no-display" focusable inset>
                    <v-expansion-panel>
                        <v-expansion-panel-header class="panelheader toolbar12">Richarge History
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="mt-5">
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="12" md="12">
                                    <v-data-table v-if="richarge_history != ''" dense class="elevation-1 mytable"
                                        :headers="headers" :items="bookList1" fixed-header @current-items="getFiltered">
                                        <template v-slot:top class="pb-5">
                                            <v-row justify="center" align="center">
                                                <tr class="t-row">
                                                    <div>
                                                        <th>
                                                            <v-row>
                                                                <span v-for="header in headers" :key="header.text">
                                                                    <span v-if="filters.hasOwnProperty(header.value)">
                                                                        <v-autocomplete class="mr-2 pb-5 pt-2" flat
                                                                            hide-details small rounded dense outlined
                                                                            color="#0F2027" :label="header.text"
                                                                            multiple clearable
                                                                            :items="columnValueList(header.value)"
                                                                            v-model="filters[header.value]"></v-autocomplete>
                                                                    </span>
                                                                </span>
                                                            </v-row>
                                                        </th>
                                                    </div>
                                                </tr>
                                            </v-row>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <br />
                <v-expansion-panels class="expapanel no-display" focusable inset>
                    <v-expansion-panel>
                        <v-expansion-panel-header class="panelheader toolbar12">Billing History
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="mt-5">
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="12" md="12" lg="12">
                                    <v-icon color="error">*</v-icon>
                                    From Date ::
                                    <input class="mt-7 pt-0" id="datePickerId" type="date" v-model="fromdate" />
                                    <v-icon color="error" class="ml-3">*</v-icon>
                                    To Date ::
                                    <input class="mt-7 ml-2 pt-0" id="datePickerId" type="date" v-model="todate" />
                                    <v-btn class="button" @click="getBillingHistory()">Proceed</v-btn>
                                </v-col>
                                <v-data-table v-if="billing_history != ''" dense class="elevation-1 mytable"
                                    :headers="headers1" :items="billing_history" fixed-header>
                                    <template v-slot:item.details="{ item }">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon color="black"
                                                        @click="getBillHistory(item)">mdi-eye</v-icon></v-btn>
                                            </template>
                                            <span> View Details</span>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </v-card>
        <v-dialog v-model="dialog_bill_details" persistent max-width="1500px">
            <v-card>
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Bill Details
                        </strong>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="dialog_bill_details=false"><v-icon> mdi-close
                        </v-icon></v-btn>
                </v-toolbar>
                <v-col v-if="billing_history_details!=null" cols="12" sm="12" md="`12">
                    <!-- { "date": "06/Mar/2023", "debit_history": [], "balance": 100, "th_id": 3, "credit_history": [ { "date": "06/Mar/2023", "amount": 100, 
                    "paymentmode": "Online", "transaction_type": "Online" } ], 
                    "count": 1, "credit_amount": 100, "transactiontype": "Credit" } -->
                    <span v-if="billing_history_details.transactiontype == 'Credit'">
                        <v-data-table v-if="billing_history_details.credit_history != ''" dense
                            class="elevation-1 mytable" :headers="headers2"
                            :items="billing_history_details.credit_history" fixed-header>
                        </v-data-table>
                    </span>
                    <span v-if="billing_history_details.transactiontype == 'Debit'">
                        <v-data-table v-if="billing_history_details.debit_history != ''" dense
                            class="elevation-1 mytable" :headers="headers3"
                            :items="billing_history_details.debit_history" fixed-header>
                        </v-data-table>
                    </span>
                    <!-- {{billing_history_details.transactiontype}} -->
                </v-col>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            snackbar_msg: "",
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            comp_load: false,
            loader: false,
            confirm_dialog: false,
            confirm_dialog_paid_till_now: false,
            stud_list: null,
            stud_data: null,
            basic_student_data: null,
            current_wallet_balance: null,
            bank_list: null,
            mode_list: null,
            trans_id: null,
            mode: null,
            bank: null,
            menu12: false,
            mode_date: null,
            amount: null,
            richarge_history:[],
             fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
            todate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1).toISOString().substr(0, 10),
            billing_history:[],
            billing_history_details:null,
            dialog_bill_details:false,
             filterArr: [],
                filters: {
                   transaction_type:[],
                   date:[],
                },
                 headers: [
                { text: "Sr No", value: "count" },
                { text: "Amount In Rs.", value: "amount" },
                { text: "Transaction Date", value: "date" },
                { text: "Transaction Type", value: "transaction_type" },
            ],
            headers1: [
                { text: "Sr No", value: "count" },
                { text: "Transaction Date", value: "date" },
                { text: "Debit Amount", value: "debit_amount" },
                { text: "Credit Amount", value: "credit_amount" },
                { text: "Balance Amount", value: "balance" },
                { text: "Details", value: "details" },
                
            ],
             headers3: [
                { text: "Item", value: "item" },
                { text: "Transaction Date", value: "order_date" },
                { text: "Order Id", value: "orderid" },
                { text: "Rate", value: "rate" },
                { text: "Quantity", value: "quantity" },
                { text: "Total Amount In Rs.", value: "amount" },
            ],

            headers2: [
                { text: "Amount In Rs.", value: "amount" },
                { text: "Transaction Date", value: "date" },
                { text: "Transaction Type", value: "transaction_type" },
                { text: "Payment Mode", value: "paymentmode" },
            ],
        }),
         computed: {
            bookList1() {
                return this.richarge_history.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        mounted() {
            this.comp_load = true;
            axios
                .post("/admission/getAllStudents_for_account")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        methods: {
               getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.richarge_history.map((d) => d[val]);
            },
             getBillHistory(item){
                this.billing_history_details = item
                this.dialog_bill_details = true
            },
            getBillingHistory(){
                 const formData = {
                    learner_id: this.stud_data.lid,
                    fromdate:this.fromdate,
                    todate:this.todate
                };
                axios
                    .post("/Wallet/getBillingHistory", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                           this.billing_history = res.data.billing_history
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.flag_reasone);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {});
            },
            payFee(){
                this.loader = true
                const formData = {
                    learner_id: this.stud_data.lid,
                    amount:this.amount,
                    mode:this.mode,
                    bank:this.bank,
                    trans_id:this.trans_id,
                   // trans_date:this.mode_date
                }
                 axios
                    .post("/Wallet/offlineWalletPayment", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                             this.showSnackbar("#4CAF50", this.amount + " Rs. Successfully Added To Wallet ...");
                           this.getData()
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.flag_reasone);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.loader = false
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(()=>{
                        this.trans_id = null,
                        this.mode = null,
                        this.bank = null,
                        this. menu12 = false,
                        this.mode_date = null,
                        this.amount = null
                    })
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getData() {
                this.basic_student_data = null;
                const formData = {
                    learner_id: this.stud_data.lid,
                };
                axios
                    .post("/Wallet/offlineWalletPaymentHome", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.basic_student_data = res.data.basic_student_data;
                            this.current_wallet_balance = res.data.current_wallet_balance;
                            this.mode_list = res.data.mode_list;
                            this.bank_list = res.data.bank_list;
                            this.richarge_history = res.data.richarge_history;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.flag_reasone);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {});
            },
        },
    };
</script>
<style scoped>
input[type="date"] {
  width: 30%;
  display: inline-block;
  padding: 0.3rem;
  border: 1px solid gray;
  border-radius: 30px;
  box-sizing: border-box;
  padding-top: none !important;
  margin-top: none !important;
}
.toolbar12 {
  background:#E57C23;/* #8360c3; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #E57C23
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #E57C23
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: white !important;
}
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }
    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable2 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .flash {
   animation-name: flash;
    animation-duration: 0.9s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    animation-play-state: running;
}

@keyframes flash {
    from {color: red;}
    to {color: white;}
}
</style>
